import * as React from 'react';
import {transparentize} from 'polished';
import styled from 'styled-components';
import {useRouteNode} from 'react-router5';
import Container from 'containers/Container';

const Locations = styled.ol`
  align-items: center;
  grid-auto-flow: column;
  display: inline-grid;
  
  list-style: none;
  margin: 17px 0;
  padding: 0;
`;

const Location = styled.li`
  align-items: center;
  grid-auto-flow: column;
  display: inline-grid;
  
  line-height: 16px;
  font-size: 12px;
  color: ${({theme}) => `
    ${transparentize(.6, theme.variables.color)};
  `};
  
  &:not(:last-child):after {
    margin: 0 8px;
    content: "/";
  }
`;

/**
 * This component renders breadcrumbs.
 * @return {React.ReactElement | null}
 * @constructor
 */
export default function Breadcrumbs(): React.ReactElement | null {
  const {route} = useRouteNode('');
  const locations = route?.name.split('.');

  if (!locations) return null;

  /**
   * This function renders the location.
   * @param {string} location
   * @param {number} index
   * @return {JSX.Element}
   */
  function renderLocation(location: string, index: number): JSX.Element {
    /**
     * This function returns the name of the path.
     * @return {string | undefined}
     */
    function getLabel(): string | undefined {
      switch (location) {
        case 'create': return 'Создать';
        case 'edit': return 'Редактировать';
        case 'courses': return 'Курсы';
        case 'course': return 'Курс';
        case 'lesson': return 'Урок';
        case 'lessons': return 'Уроки';
        case 'library': return 'Библиотека';
        case 'settings': return 'Настройки';
        case 'webinars': return 'Вебинары';
        case 'webinar': return 'Вебинар';
        case 'students': return 'Студенты';
        case 'student': return 'Студент';
        case 'payments': return 'Оплаты';
        case 'tasks': return 'Задания';
        case 'task': return 'Задание';
        case 'progress': return 'Вполнение';
        case 'view': return 'Просмотр';
        case 'recipes': return 'Рецепты';
        case 'ingredients': return 'Ингредиенты';
        case 'exercises': return 'Упражнения';
        case 'exercise': return 'Упражнение';
      }
    }

    return (
      <Location key={index}>
        {getLabel()}
      </Location>
    );
  }

  return (
    <Container>
      <Locations>
        {locations.map((location, index) => (
          renderLocation(location, index)
        ))}
      </Locations>
    </Container>
  );
}
